import script from "./OrderFinalInvoiceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderFinalInvoiceModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderFinalInvoiceModal.vue?vue&type=style&index=0&id=0c11aa30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c11aa30"]])

export default __exports__